import cliente_model from '@/shared/models/cliente_model';
import estado_solicitud_model from '@/shared/models/estado_solicitud_model';
import usabilidad_model from '@/shared/models/usabilidad_model';
import prices_elemento_model from './prices_elemento_model';
import prices_producto_model from './prices_producto_model';
import elemento_tipo_model from '@/shared/models/elemento_tipo_model';

export default {
  Codigo: null,
  Cliente: { ...cliente_model },
};

export const Usuario = {
  Codigo: null,
  Usuario: null,
  Nombre: null,
  Apellido: null,
  Password: null,
  Activo: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  RolUsuario: [],
};

export const Cliente = {
  Codigo: null,
  Descripcion: null,
  CodigoSecundario: null,
  Contacto: null,
  Email: null,
  Telefono: null,
  Giro: null,
  Margen: null,
  Activo: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  UsuarioCreacion: { ...Usuario },
  UsuarioActualizacion: { ...Usuario },
  UsuarioVendedorPrincipal: null,
  UsuarioVendedorSecundario: null,
};

export const UnidadMedida = {
  Codigo: null,
  Descripcion: null,
  Abreviatura: null,
  EsUnidadVenta: null, //boolean
  Activo: null,
  CotizacionCantidadCosto: [],
  Costo: [],
  Material: [],
};

export const CondicionPago = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};
export const Validez = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};
export const Moneda = {
  Codigo: null,
  Descripcion: null,
  Abreviatura: null,
  Activo: true,
};
export const Usabilidad = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

export const CotizacionCantidadCosto = {
  Codigo: null,
  CodigoCotizacion: null,
  CodigoCotizacionElemento: null,
  CodigoCotizacionCantidad: null,
  ItemCosto: null,
  CodigoCosto: 1,
  CodigoMonedaCosto: null,
  Cantidad: null,
  CodigoUnidadMedida: null,
  PrecioUnitarioOriginal: null,
  PrecioUnitario: null,
  PrecioTotalOriginal: null,
  PrecioTotal: null,
  CodigoMonedaPrecio: null,
  Activo: null,
  MonedaPrecio: Moneda,
  MonedaCosto: Moneda,
  UnidadMedida,
};

export const CotizacionCantidad = {
  Codigo: null,
  CodigoCotizacion: null,
  ItemCantidad: null,
  Cantidad: null,
  Descuento: null,
  CostoTotalOriginal: null,
  MargenOriginal: null,
  MargenMontoOriginal: null,
  ComisionOriginal: null,
  ComisionMontoOriginal: null,
  CostoTotal: null,
  Margen: null,
  MargenMonto: null,
  Comision: null,
  ComisionMonto: null,
  PrecioTotal: null,
  PrecioUnidadVenta: null,
  Aprobada: null, //boolean
  CodigoMoneda: null,
  CodigoUsuarioAprobacion: null,
  FechaAprobacion: null,
  CotizacionCantidadCosto: [],
  UsuarioAprobacion: { ...Usuario },
  Moneda,
};

export const CotizacionAdjunto = {
  Codigo: null,
  CodigoCotizacion: null,
  ItemAdjunto: null,
  Url: null,
};

export const MaterialCategoria = {
  Codigo: null,
  Descripcion: null,
  Activo: null,
};

export const MaterialTipo = {
  Codigo: null,
  Descripcion: null,
  CodigoMaterialCategoria: null,
  Activo: null,
  MaterialCategoria,
};

export const Suaje = {
  Codigo: null,
  CodigoSuaje: null,
  TienePleca: null,
  Engrane: null,
  MedidaEjeMm: null,
  MedidaDesarrolloMm: null,
  GapEjeMm: null,
  GapDesarrolloMm: null,
  MedidaEjeIn: null,
  MedidaDesarrolloIn: null,
  GapEjeIn: null,
  GapDesarrolloIn: null,
  EtiquetasEje: null,
  EtiquetasDesarrollo: null,
  AnchoOptimoMaterial: null,
  Activo: true,
};

export const Centro = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

export const Matriz = {
  Codigo: null,
  Descripcion: null,
  TipoCalculo: null,
  Activo: true,
};

export const Proceso = {
  Codigo: null,
  Descripcion: null,
  CodigoMatriz: null,
  CodigoMaterialCategoria: null,
  Material: true,
  Dimensiones: true,
  Bocas: true,
  Porcentaje: true,
  Activo: true,
  Matriz: { ...Matriz },
  MaterialCategoria,
};

export const RecursoTipo = {
  Codigo: null,
  Descripcion: null,
  CodigoEquivalente: null,
  Activo: true,
};

export const Recurso = {
  Codigo: null,
  Descripcion: null,
  CodigoRecursoTipo: null,
  CodigoRenglonEquivalente: null,
  CostoHora: null,
  CodigoMoneda: null,
  MetrosPreparacion: null,
  MetrosColor: null,
  PorcentajeMerma: null,
  TiempoPreparacionFijo: null,
  TiempoPreparacionColor: null,
  PromedioProduccion: null,
  PromedioProduccionTroquelado: null,
  Activo: true,
  CodigoTipoCilindro: null,
  AnchoMinimo: null,
  AnchoMaximo: null,
  Colores: null,
  CantidadEstacionesSuaje: null,
  CantidadCuerposUv: null,
  SuajeMagnetico: null, //boolean
  Laminacion: null, //boolean
  ColdFoil: null, //boolean
  BackPrint: null, //boolean
  Reverso: null, //boolean
  EmbobinadoresEnLinea: null, //boolean
  InkjetEnLinea: null, //boolean
  Silicon: null, //boolean
  Stacker: null, //boolean
  RecursoTipo,
  Moneda,
};

export const MateriaPrimaFamilia = {
  Codigo: null,
  Descripcion: '',
  CodigoAdicional: null,
  Activo: true,
};

export const Material = {
  Codigo: null,
  CodigoMaterialTipo: null,
  CodigoFamilia: null,
  DescripcionInterna: null,
  CodigoAdicional: null,
  Costo: null,
  CodigoMoneda: null,
  CodigoUnidadMedida: null,
  Activo: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  MaterialTipo,
  MateriaPrimaFamilia,
  Moneda,
  UnidadMedida,
  // UsuarioCreacion:{...Usuario},
  // UsuarioActualizacion:{...Usuario}
};

export const CotizacionElementoProceso = {
  Codigo: null,
  CodigoCotizacion: null,
  CodigoCotizacionElemento: null,
  CodigoProceso: null,
  ItemProceso: null,
  CodigoRecurso: null,
  CodigoMateriaPrimaFamilia: null,
  Observaciones: null,
  Proceso,
  Recurso,
  MateriaPrimaFamilia,
  Velocidad: 0,
  Cantidad: null,
  BocasAnchoFinales: null,
  Costo: null,
  Adicional: false,
  PorcentajeMerma: 0,
  CodigoSentidoBobinado: null,
  CotizacionElementoProcesoMateriales: [],
  FueraDeLinea: false,
};

export const CotizacionElementoProcesoMateriales = {
  Codigo: null,
  CodigoCotizacionElementoProceso: null,
  CodigoMaterial: null,
  Porcentaje: null,
  Espesor: null,
  Gramaje: null,
  BocasAncho: null,
  BocasLargo: null,
  BocasAlto: null,
  Ancho: null,
  Largo: null,
  Material: { ...Material },
};

export const Tinta = {
  Codigo: null,
  DescripcionInterna: null,
};
export const TintaTipo = {
  Codigo: null,
  Descripcion: null,
  Activo: null,
  Rendimiento: null,
  Costo: null,
  CodigoMoneda: null,
  Moneda,
};

// export const CotizacionElementoTinta = {
//   Codigo: null,
//   CodigoCotizacion: null,
//   CodigoCotizacionElemento: null,
//   ItemTinta: null,
//   LadoAplicacion: null,
//   CodigoTinta: null,
//   CodigoTintaTipo: null,
//   Cobertura: null,
//   MatrizAdicional: null,
//   kilos: null,
//   TintaMaterial: { ...Material },
//   TintaTipo
// }

export const Forma = {
  Codigo: null,
  Descripcion: null,
  Activo: null,
};

export const CotizacionElemento = {
  AnchoMaterial: null,
  CantidadCambios: null,
  CantidadColoresAdhesivo: null,
  CantidadColoresFrente: null,
  CantidadColoresLiner: null,
  CantidadPolimeros: null,
  Codigo: null,
  CodigoCotizacion: null,
  CodigoElementoTipo: null,
  CodigoForma: null,
  CodigoMateriaPrimaFamilia: null,
  CodigoSuaje: null,
  CotizacionCantidadCosto: [],
  CotizacionElementoProceso: [], // Este es un array de objetos.
  // CotizacionElementoTinta: [], // Este es un array de objetos.
  Desarrollo: null,
  Engranaje: null,
  EtiquetasDesarrollo: null,
  EtiquetasEje: null,
  Forma,
  GapDesarrollo: null,
  GapEje: null,
  ItemElemento: null,
  Laterales: null,
  AnchoMinimoMaterial: null,
  LargoMinimoMaterial: null,
  MateriaPrimaFamilia,
  MedidaDesarrollo: null,
  MedidaEje: null,
  PaquetesPorCaja: null,
  Suaje,
  UnidadMedida: 'mm',
  MargenSuperior: null,
  ElementoTipo: { ...elemento_tipo_model },
};

export const CotizacionProducto = {
  Codigo: null,
  CodigoCotizacion: null,
  ItemProducto: null,
  CodigoEspecificacionTecnica: null,
  Descripcion: null,
  CotizacionProductoCantidad: [],
  Repeticion: null,
  CantidadBocas: null,
};

export const CotizacionProductoCantidad = {
  Codigo: null,
  CodigoCotizacionProducto: null,
  ItemCantidad: null,
  Cantidad: null,
};

export const MotivoRechazo = {
  Codigo: null,
  Descripcion: null,
  Activo: null,
};

export const initialPrices = {
  Codigo: null,
  CodigoSolicitud: null,
  CodigoEstado: null,
  FechaEstado: null,
  CodigoCliente: null,
  ObservacionesSolicitud: null, // Recibe de la solicitud
  Observaciones: null, // Viaja hacia la ET / OT
  Notas: null,
  Referencia: null,
  CodigoUsabilidad: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  Estado: { ...estado_solicitud_model, Codigo: 1 },
  Cliente: { ...cliente_model },
  CotizacionAdjunto: [],
  CotizacionProducto: [{ ...prices_producto_model, ItemProducto: 1 }],
  CotizacionElemento: [{ ...prices_elemento_model, ItemElemento: 1 }],
  CotizacionEntregas: [],
  CotizacionCantidad: [],
  CotizacionCantidadCosto: [],
  Usabilidad: { ...usabilidad_model },
};
